import React, { useEffect, useState } from "react";
import { useAuth } from "../context/auth";
import { usePayment } from "../context/payment";
import { useNavigate } from "react-router-dom";

import Button from "../components/Button";
import Login from "../components/Login";
import Register from "../components/Register";
import PaymentButton from "../components/PaymentButton";
import Counter from "../components/Counter";
import MainWrapper from "../components/MainWrapper";

export default function LandingScreen() {
  const { currentUser } = useAuth();
  const { hasPaid } = usePayment();
  const navigate = useNavigate();
  const [view, setView] = useState("landing");

  const handleRegister = () => setView("register");
  const handleLogin = () => setView("login");
  const returnToLanding = () => setView("landing");

  const renderUnauthenticated = () => {
    switch (view) {
      case "register":
        return <Register returnToLanding={returnToLanding} />;
      case "login":
        return <Login returnToLanding={returnToLanding} />;
      default:
        return (
          <div className="column">
            <Button onClick={handleRegister} className="form-margin">
              Register
            </Button>
            <Button onClick={handleLogin}>Log in</Button>
          </div>
        );
    }
  };

  const renderAuthenticated = () => {
    if (view === "play") {
      // If the user hasn't paid, show the payment UI.
      if (!hasPaid) {
        return (
          <div className="column notice">
            <p>The cost of your visit comes to:</p>
            <h3>£3.33</h3>
            <p>Kind regards</p>
            <p>KYEWB Management</p>
            <PaymentButton />
          </div>
        );
      } else {
        // If the user has paid, redirect to the warning screen.
        navigate("/warning", { state: { demo: false } });
      }
    }

    // Default authenticated landing view.
    return (
      <div className="column">
        <Button
          style={{ marginBottom: 10 }}
          className="form-margin"
          onClick={() => navigate("/warning", { state: { demo: true } })}
        >
          Hotel Tour (Demo)
        </Button>
        <Button onClick={() => setView("play")}>
          Check in to KYEWB (Full Game)
        </Button>
      </div>
    );
  };

  return (
    <MainWrapper>
      {!currentUser ? renderUnauthenticated() : renderAuthenticated()}
    </MainWrapper>
  );
}
